var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.protocol},[_c('the-protocol-preface'),_vm._v(" "),_c('div',{class:_vm.$style.list},_vm._l((_vm.list),function(el,index){return _c('the-protocol-item',{key:index,attrs:{"data":el,"index":index}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }